import React from 'react';
import ReactTooltip from 'react-tooltip';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Linkify from 'react-linkify';
import Modal from '../../common/Modal';
import Button from '../../common/Button';
import ProjectEdit from '../edit/';
import ProjectEditStatus from '../edit-status/';
import ProjectJoinUser from '../join-user/';
import Render from '../../common/Render';
import Avatar from '../../common/Avatar';
import Memos from './memos';
import ProjectLogo from '../../common/ProjectLogo';
import * as projectDetailsDuck from './duck';
import * as userDuck from '../../user/duck';

class Screen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddUserToProjectModalOpen: false,
      isEditProjectInfoModalOpen: false,
      isEditProjectStatusModalOpen: false,
    };
  }

  handleAddUserToProjectModalOpen = () => {
    this.setState({
      isAddUserToProjectModalOpen: true,
    });
  };
  handleAddUserToProjectModalClose = () => {
    this.setState({
      isAddUserToProjectModalOpen: false,
    });
  };

  handleEditProjectInfoOpen = () => {
    this.setState({ isEditProjectInfoModalOpen: true });
  };
  handleEditProjectInfoClose = () => {
    this.setState({ isEditProjectInfoModalOpen: false });
  };

  handleEditProjectStatusOpen = () => {
    this.setState({ isEditProjectStatusModalOpen: true });
  };

  handleEditProjectStatusClose = () => {
    this.setState({ isEditProjectStatusModalOpen: false });
  };

  componentDidMount() {
    const { projectId } = this.props;
    this.props.requestProjectDataIfNeeded({ projectId });
  }

  componentDidUpdate(prevProps) {
    const currentProjectId = this.props.projectId;
    const isDifferentProject = currentProjectId !== prevProps.projectId;
    if (isDifferentProject) {
      this.props.requestProjectDataIfNeeded({ projectId: currentProjectId });
    }
  }

  renderUrl = (url, hasMoreLinks) => {
    const { t } = this.props;

    if (!url) {
      return null;
    }

    return (
      <div
        className={`u-display-flex u-align-items-center ${
          hasMoreLinks ? 'u-margin-bottom-small' : ''
        }`}
      >
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="c-box-primary__text c-box-primary__link c-box-primary__link--static"
        >
          <strong>{t('general.functionalSpecification')}</strong>
        </a>
      </div>
    );
  };

  renderUrls = (urls) => {
    return urls.map((url, i) => (
      <div
        key={i}
        className={`u-display-flex u-align-items-center ${
          // add margin bottom to all items, except the last one
          urls.length !== i + 1 ? 'u-margin-bottom-small' : ''
        }`}
      >
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="c-box-primary__text c-box-primary__link c-box-primary__link--static"
        >
          {url}
        </a>
      </div>
    ));
  };

  renderUsers = (users) => {
    const projectId = this.props.project._id;

    return users.map((user) => (
      <Link key={user._id} to={`/users/${user._id}`}>
        <Avatar
          data-tip={user.name}
          data-for={projectId + user._id}
          className="u-margin-right"
          src={user.getSmallAvatarUrl()}
          width="55"
          height="55"
        />
        <ReactTooltip
          id={projectId + user._id}
          className="c-tooltip"
          effect="float"
        />
      </Link>
    ));
  };

  renderTitle = (project) => {
    switch (project.type) {
      default:
      case 'DEFAULT':
        return (
          <h3 className="u-margin-bottom-none u-color-blue-violet">
            {`[${project.name}]`}
          </h3>
        );
      case 'SIDE':
        return (
          <h3 className="u-margin-bottom-none u-color-shakespeare">
            {`{${project.name}}`}
          </h3>
        );
    }
  };

  handleProjectUpdateSuccess = () => {
    // Basically update all related entities.
    // Not the best option, but for sure - the fastest one.
    const { projectId } = this.props;
    this.props.requestUserDataIfNeeded();
    this.props.requestProjectDataIfNeeded({ projectId });

    this.handleEditProjectInfoClose();
  };

  renderAfterLoading = () => {
    const {
      project,
      activeUsers,
      unactiveUsers,
      t,
      enableEditing,
      displayChangeProjectStatusBtn,
      currentlyLoggedInUserStatus,
      displayAddUserToProjectBtn,
    } = this.props;
    // const { isEditProjectInfoModalOpen } = this.state;
    const {
      isAddUserToProjectModalOpen,
      isEditProjectInfoModalOpen,
      isEditProjectStatusModalOpen,
    } = this.state;

    // Happens when the project is hided (deleted). API returns empty project.
    // However, when the project ID is bad (missing, unknown),
    // API returns a proper error.
    if (!project) {
      return t('project.edit.notFound');
    }

    const hasLinks =
      !_.isEmpty(project.urls) || !_.isEmpty(project.moreInfoUrl);

    return (
      <div className="u-margin-bottom-huge">
        <div className="u-margin-bottom u-display-flex u-flex-wrap u-justify-content-between u-align-items-center">
          <div className="u-display-flex u-align-items-center">
            <ProjectLogo width="70" height="70" src={project.logoUrl} />
            {this.renderTitle(project)}
          </div>
          {displayAddUserToProjectBtn && (
            <Button
              styleType="outline"
              onClick={this.handleAddUserToProjectModalOpen}
            >
              {t('project.edit.addYourself')}
            </Button>
          )}
          {displayChangeProjectStatusBtn && (
            <Button
              styleType="outline"
              onClick={this.handleEditProjectStatusOpen}
            >
              {t('project.edit.editInvolvementStatus')}
            </Button>
          )}
        </div>

        <div className="o-layout o-layout--large">
          <div className="o-layout__item u-1/1 u-1/1@mini-geri">
            <div className="u-display-flex u-justify-content-between u-align-items-center">
              <h4 className="u-margin-top-micro">
                {t('project.details.title')}
              </h4>
              {enableEditing && (
                <button
                  onClick={this.handleEditProjectInfoOpen}
                  className="c-btn c-btn--edit c-btn--effect u-padding-right-none"
                >
                  {t('general.edit')}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="o-layout o-layout--large u-margin-bottom-huge">
          <div className="o-layout__item">
            <div className="c-box c-box-primary">
              <div className="c-box-primary__box">
                <div className="c-box-primary__text display-linebreak">
                  <Linkify
                    properties={{
                      target: '_blank',
                      className: 'u-color-blue-violet',
                    }}
                  >
                    {project.description}
                  </Linkify>
                </div>
              </div>
              {hasLinks && (
                <div className="c-box-primary__box">
                  <div className="c-box-primary__text">
                    {this.renderUrl(project.moreInfoUrl, !!project.urls.length)}
                    {this.renderUrls(project.urls)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal
          isOpen={isEditProjectStatusModalOpen}
          onRequestClose={this.handleEditProjectStatusClose}
          title={t('project.edit.editInvolvementStatusTitle')}
        >
          <ProjectEditStatus
            project={project}
            status={currentlyLoggedInUserStatus}
            onSuccess={this.handleProjectUpdateSuccess}
          />
        </Modal>

        <Modal
          isOpen={isAddUserToProjectModalOpen}
          onRequestClose={this.handleAddUserToProjectModalClose}
          title={t('project.join.joinUserToProjectTitle')}
        >
          <ProjectJoinUser project={project} />
        </Modal>

        <Modal
          isOpen={isEditProjectInfoModalOpen}
          onRequestClose={this.handleEditProjectInfoClose}
          title={t('project.edit.editInfoTitle')}
        >
          <ProjectEdit
            type={project.type}
            project={project}
            onSuccess={this.handleProjectUpdateSuccess}
          />
        </Modal>

        {activeUsers &&
          activeUsers.length > 0 && (
            <React.Fragment>
              <h4 className="u-margin-bottom-large">
                {t('project.details.titleActivelyWorkingMembers')}
              </h4>
              <div className="u-margin-bottom-huge c-avatar__box">
                {this.renderUsers(activeUsers)}
              </div>
            </React.Fragment>
          )}

        {unactiveUsers &&
          unactiveUsers.length > 0 && (
            <React.Fragment>
              <h4 className="u-margin-bottom-large u-opacity-half">
                {t('project.details.titleInactivelyWorkingMembers')}
              </h4>
              <div className="u-opacity-half c-avatar__box u-margin-bottom-huge">
                {this.renderUsers(unactiveUsers)}
              </div>
            </React.Fragment>
          )}

        <div id="lexicon">
          <Memos project={project} />
        </div>

        {/* TODO: */}
        {/* <h3 className="u-margin-top-huge u-margin-bottom-large">
          Members also involved in
          </h3> */}
      </div>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = ({ projectDetails, user, workspace }, { match }) => {
  const { projectId } = match.params;
  const project = projectDetails.data;

  // Filter out only the users who activelly work on this project
  const activeUsers =
    project &&
    project.users.filter((u) =>
      u.projects.find(
        (pr) => pr.project === project._id && pr.status === 'ACTIVE'
      )
    );

  // Filter out only the users
  // who have marked that they no longer work on this project (inactive)
  const unactiveUsers =
    project &&
    project.users.filter((u) =>
      u.projects.find(
        (pr) => pr.project === project._id && pr.status === 'INACTIVE'
      )
    );

  // User should be able to edit only projects he is involved in
  const isAdmin = user.data && workspace.data.admins.includes(user.data._id);
  const isProjectOneOfUserProjects =
    user.data &&
    user.data.projects.find((item) => item.project._id === projectId);

  // Same logic like enable editting - display the button only to the user
  // who is involved in this project
  const displayChangeProjectStatusBtn = isProjectOneOfUserProjects;
  // The opposite logic of enable editting - display only
  // if the user is not involved in this project
  const displayAddUserToProjectBtn = !isProjectOneOfUserProjects;
  const currentProject =
    user.data &&
    user.data.projects.find((item) => item.project._id === projectId);

  return {
    isLoading: projectDetails.isLoading,
    error: projectDetails.error,
    project,
    activeUsers,
    unactiveUsers,
    projectId,
    enableEditing: isProjectOneOfUserProjects || isAdmin,
    displayChangeProjectStatusBtn,
    displayAddUserToProjectBtn,
    currentlyLoggedInUserStatus: currentProject ? currentProject.status : null,
  };
};

const mapDispatchToProps = {
  requestUserDataIfNeeded: userDuck.requestDataIfNeeded,
  requestProjectDataIfNeeded: projectDetailsDuck.requestDataIfNeeded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/projects/details/Screen.js